<!-- MODULO IMG DESTRA + TESTO SINISTRA -->
<div class="container mb-5 modulo testo">
  <div class="row">
    <div class="col-12 col-md-6 mb-3 mb-md-0" [innerHTML]="campi.TESTO?.valore | safe">    
    </div>
    <div class="col-12 col-md-6">
      <img *ngIf="campi.IMMAGINE?.valore" class="img-fluid mx-auto mb-4" [appSrcDesktopLandscape43]="campi.IMMAGINE?.valore?.path" [alt]="campi.IMMAGINE.valore.alt">
      
    </div>
  </div>
</div>
<!-- //MODULO MODULO IMG DESTRA + TESTO SINISTRA -->